import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function Footer(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px",
					borderTop: "1px solid var(--secondaryColor)"
				}}
			>
				<div className="container">
					<div className="row">
						
						<div className="col-md-4">
							<h6
								className="main-section-title text-start"
							>
								Useful Links
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "",
									})
								}}
								className="btn font-bold text-light"
							>
								Home
							</h6>

							
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "about_us",
									})
								}}
								className="font-bold text-light"
							>
								About Us
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "services",
									})
								}}
								className="font-bold text-light"
							>
								Services
							</h6>

              <h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "projects",
									})
								}}
								className="font-bold text-light"
							>
								Projects
							</h6>

              <h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "gallery",
									})
								}}
								className="font-bold text-light"
							>
								Gallery
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "contact_us",
									})
								}}
								className="font-bold text-light"
							>
								Contact Us
							</h6>
						</div>

						<div className="col-md-4">
							<h6
								className="main-section-title text-start"
							>
								Address
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
					className="font-bold text-light"
				>
					 P.O.Box 3362
					<br/>Rock City Mall
					<br/>Makongoro Road
					<br/>Mwanza Tanzania
				</h6>
			</div>

			<div className="col-md-4">
				<h6
					className="main-section-title text-start"
				>
					Reach Out
				</h6>

				<h6
					style={{
						fontSize: "14px",
						padding: "10px",
					}}
					className="font-bold text-light"
				>
					Email: <span> info@kitchenkings.co.tz</span> <br/>
					Phone: <span>  +255 (0) 679 101 107 | +255 (0) 719 423 242 </span>
				</h6>

			</div>

			<div className="col-md-12 text-center font-bold">
				<h6
					style={{
						fontSize: "14px",
						paddingTop: "30px"
					}}
					className="text-light"
				>
					&copy; KITCHEN KINGS TZ - {getCurrentYear()}
				</h6>
							<hr />
							<br />
							<h6>
								website designed by <a href="http://werenium.com" target="_blank">Werenium Technologies</a>
							</h6>
						</div>
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}